import axios from 'axios'
import config from '../Config/config'

const service = axios.create({
    baseURL: config['API_ENDPOINT'],
    timeout: 10000,
})

export default service